const o = 396, E = "apeiron_use_cookie";
export {
  o as COOKIE_EXPIRES,
  E as COOKIE_NAME
};
//# sourceMappingURL=consent.js.map
